<template>
  <v-row class="justify-center align-center fill-height">
    <v-card class="custom-card align-center justify-center d-flex fill-height" style="width: 100%; height: 100%;" elevation="0">
      <div>
        <v-carousel
          v-model="currentSlide"
          hide-delimiters
          :show-arrows="false"
          height="300"
          cycle
          interval="3000"
          class="carousel-wrapper"
        >
          <v-carousel-item
            v-for="(slide, index) in slides"
            :key="index"
            :value="index"
          >
            <div class="carousel-content">
              <v-img :src="slide.image" class="carousel-image"></v-img>
            </div>
          </v-carousel-item>
        </v-carousel>

        <v-row class="justify-center mt-5 mb-5">
          <div
            v-for="(slide, index) in slides"
            :key="index"
            @click="currentSlide = index"
            :class="['custom-delimiter', { active: currentSlide === index }]"
          ></div>
        </v-row>

        <v-row class="justify-center text-center px-5">
          <div>
            <h1 class="carousel-title">{{ slides[currentSlide].title }}</h1>
            <p class="carousel-description">
              {{ slides[currentSlide].description }}
            </p>
          </div>
        </v-row>
      </div>
    </v-card>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      currentSlide: 0,
      slides: [
        {
          image: this.$theme.aberturaDeConta,
          title: 'Abra contas para seus clientes\nem minutos',
          description:
            'Crie contas para seus clientes em apenas alguns cliques, preenchendo apenas alguns passos;\nTenha acesso ao número da conta no momento da abertura.',
        },
        {
          image: this.$theme.acompanheProcesso,
          title: 'Você no controle',
          description:
            'Tenha a flexibilidade de escolher quem continuará o processo de abertura da conta corrente: você ou seu cliente.',
        },
        {
          image: this.$theme.voceNoControle,
          title: 'Acompanhe o processo de\nabertura da conta do início ao fim',
          description:
            'Acompanhe o status da conta em tempo real, desde a\nabertura até a aprovação;\nReceba notificações por e-mail e SMS sobre o andamento\ndo processo.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.custom-card {
  width: 611px;
  height: 78vh;
  border: 1px solid;
  border-radius: 12px;
  border-color: #e5e5e5;
}

.carousel-image {
  width: 300px;
  height: 300px;
  margin: 0 auto;
}

.carousel-title {
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  color: var(--v-primary-base);
  width: 470px;
  white-space: pre-wrap;
  margin-bottom: 16px;
}

.carousel-description {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: #3a3939;
  width: 470px;
  white-space: pre-wrap;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(80vw);
}

.custom-delimiter {
  background-color: #D9D9D9;
  width: 14px;
  height: 6px;
  border-radius: 16px;
  margin: 0 5px;
  transition: all 0.3s ease;
}
.carousel-wrapper {
  display: flex;
  align-items: center; /* Centraliza os itens verticalmente */
  justify-content: center; /* Centraliza os itens horizontalmente */
}
.carousel-content {
  display: flex;
  align-items: center; /* Centraliza verticalmente */
  justify-content: center; /* Centraliza horizontalmente */
  height: 100%; /* Ocupa a altura total do carrossel */
}
.custom-delimiter.active {
  background-color: var(--v-primary-base);
  width: 41px;
  height: 6px;
  border-radius: 16px;
}
@media (max-width: 1400px) {
  .carousel-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
  }
  .carousel-description {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
  .carousel-image {
    width: 200px;
    height: 200px;
    margin: 0 auto;
  }
}
</style>
